import { BaseService } from '@/modules/Core/services/BaseService' // Asegúrate de tener la interfaz definida
import type {
  ICitaAgendamiento,
  ITipoGeneralesAgendamientos
} from '@/modules/Agendamiento/interfaces'
import type {
  ICitaAdmision
} from '@/modules/Admision/interfaces'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
export class AgendamientoService extends BaseService<ICitaAgendamiento> {
  constructor () {
    super({
      baseUrl: 'scheduling/scheduling/'
    })
  }

  async getGeneralesAgendamiento (
    id: number
  ): Promise<AxiosResponse<IResponseApi<ITipoGeneralesAgendamientos>>> {
    return this.http.get<IResponseApi<ITipoGeneralesAgendamientos>>(
      `/general-flash?coppId=${id}`
    )
  }
  async getCalendarLink (
    cittId: number
  ): Promise<AxiosResponse<IResponseApi<{ url: string }>>> {
    return this.http.get<IResponseApi<{ url: string }>>(`calendar-link/${cittId}`)
  }
  async updateStatusAgendamiento (
    id: number,
    data: ICitaAdmision
  ): Promise<AxiosResponse<IResponseApi<ICitaAdmision>>> {
    return this.http.put<IResponseApi<ICitaAdmision>>(`update-status/${id}`, data).catch(this.errorHandle)
  }
}
